var _path, _circle, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _rect3, _rect4, _path8, _ellipse, _ellipse2, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg03Transport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9662 32.0795C22.0812 31.8782 22.2633 31.7241 22.4782 31.6369C28.335 29.2602 32.4653 23.515 32.4653 16.8052C32.4653 7.96862 25.3019 0.805176 16.4653 0.805176C7.62878 0.805176 0.465332 7.96862 0.465332 16.8052C0.465332 23.6012 4.70239 29.4076 10.679 31.7268C10.9002 31.8127 11.0882 31.9691 11.2059 32.1752L14.8222 38.5037C15.59 39.8474 17.5274 39.8473 18.2952 38.5037L21.9662 32.0795Z",
    fill: "#5746C0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4653,
    cy: 16.8052,
    r: 13.5,
    fill: "#291F50"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.47119,
    y: 8.65659,
    width: 13.9882,
    height: 12.2947,
    rx: 1,
    fill: "#4841A6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.9082,
    y: 9.09583,
    width: 13.1139,
    height: 11.4165,
    rx: 1,
    fill: "#E7E6F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5911 20.9514H17.3396V25.3463C17.3396 25.8292 16.9482 26.2206 16.4653 26.2206V26.2206C15.9825 26.2206 15.5911 25.8292 15.5911 25.3463V20.9514Z",
    fill: "#E7E6F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5911 20.9514H17.3396V22.2927L15.5911 21.4145L15.5911 20.9514Z",
    fill: "#ABA9C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5312 12.4579C12.5312 12.2154 12.7278 12.0188 12.9703 12.0188H13.4055V12.897H12.9703C12.7278 12.897 12.5312 12.7004 12.5312 12.4579V12.4579Z",
    fill: "#4841A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4055 18.1841H15.154V18.1841C15.154 18.667 14.7626 19.0623 14.2798 19.0623V19.0623C13.7969 19.0623 13.4055 18.667 13.4055 18.1841V18.1841Z",
    fill: "#4841A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7769 18.1841H19.5254V18.1841C19.5254 18.667 19.134 19.0623 18.6511 19.0623V19.0623C18.1683 19.0623 17.7769 18.667 17.7769 18.1841V18.1841Z",
    fill: "#4841A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3994 12.4579C20.3994 12.2154 20.2028 12.0188 19.9603 12.0188H19.5252V12.897H19.9603C20.2028 12.897 20.3994 12.7004 20.3994 12.4579V12.4579Z",
    fill: "#4841A6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9683,
    y: 11.1587,
    width: 6.99409,
    height: 7.02556,
    rx: 0.5,
    fill: "#8F87F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.4055,
    y: 11.5977,
    width: 6.11983,
    height: 3.51278,
    rx: 1,
    fill: "#E7E6F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.814 11.5977H18.5267C19.079 11.5977 19.5267 12.0454 19.5267 12.5977V13.7903L14.1682 11.5977H13.814Z",
    fill: "#ABA9C8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.2798,
    cy: 16.41,
    rx: 0.874262,
    ry: 0.878195,
    fill: "#E7E6F0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.6511,
    cy: 16.41,
    rx: 0.874262,
    ry: 0.878195,
    fill: "#E7E6F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4653 13.3543L16.4666 15.1107",
    stroke: "#8F87F3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg03Transport);
export default __webpack_public_path__ + "static/media/03_transport.ae4c84bb3b7a16a4954abf18f8b46baa.svg";
export { ForwardRef as ReactComponent };